module.exports = __webpack_public_path__ + "img/instagram.5ff7fc82.png";